if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form){
        this.form.querySelector('[name="id"]').disabled = false;
      }
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.form || !this.submitButton) return;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message
            }}));
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if(!this.error) {
            this.error = false;
            pushSuccessMessage(window.cartStrings.success);
            // cart-drawer.liquid 用 Vue createApp.mount('#CartDrawer-CartItems') 渲染 cart items,
            // Vue 监听 'cartCenterChange' 事件更新 carData。直接 innerHTML 替换 sections HTML
            // 会把 Vue 渲染好的 DOM 替换成 v-for/v-if/:src 模板字符串,Vue 不重新 mount,
            // drawer 显示空白模板。正确做法是 dispatch cartCenterChange 让 Vue 自己重渲。
            //
            // 用 /cart/update.js with sections 参数(跟 cart_center.liquid 内部 change() 一致),
            // 响应里同时含完整 cart state + sections HTML map。监听器 line 1342
            // `$(e.detail.sections[sid])` 期望 sections 字段存在,缺失会报
            // `Cannot read properties of undefined (reading 'cart-drawer')`,
            // 所以必须传 sections。空 updates 不改 cart,只用来拉当前状态 + sections。
            const updateVueCartDrawer = () => {
              const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              fetch(root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  updates: {},
                  sections: ['cart-drawer', 'cart-icon-bubble'],
                  sections_url: window.location.pathname,
                }),
              })
                .then((r) => r.json())
                .then((result) => {
                  // variantMap 尽量从 cartCenter 拿,拿不到给 {};新加商品的 variant 不在
                  // cartCenter 初始化的 map 里,但 cart-drawer.liquid 用法都有 v-if/?. 守卫
                  let variantMap = {};
                  try {
                    if (typeof cartCenter !== 'undefined' && cartCenter._variantMap) {
                      variantMap = cartCenter._variantMap;
                    }
                  } catch (e) {}
                  const detail = Object.assign({}, result, { variantMap });
                  document.dispatchEvent(new CustomEvent('cartCenterChange', { detail }));
                })
                .catch((e) => console.error('updateVueCartDrawer failed:', e));
            };

            const quickAddDrawer = this.closest('quick-add-drawer');
            if (quickAddDrawer) {
              document.body.addEventListener('drawerClosed', () => {
                setTimeout(() => {
                  updateVueCartDrawer();
                  if (this.cart && typeof this.cart.open === 'function') this.cart.open();
                });
              }, { once: true });
              quickAddDrawer.close();
            } else {
              updateVueCartDrawer();
              if (this.cart && typeof this.cart.open === 'function') this.cart.open();
            }
            document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {productVariantId: formData.get('id')}}));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (document.getElementById('remove_open-drawer-fixed')){
            // document.body.style.overflow='auto';
          }
          // ChangeTheNumberOfCarts();


        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
